export default {
  getPxFromRem: (rem: number) => {
    const rootRem = 16
    return `${rootRem * rem}px`
  }
}
